<template>
  <div class="tw-flex tw-size-full tw-items-center tw-justify-center tw-p-3">
    <span
      class="tw-text-sm tw-font-medium"
      :style="{ color: `rgb(var(--tw-color-${props.primaryColor}))` }"
      >Selected</span
    >
  </div>
</template>

<script setup lang="ts">
import { Colors } from '@/api';

interface Props {
  primaryColor: Colors;
}

const props = defineProps<Props>();
</script>
